import { connect } from '@giantmachines/redux-websocket';

export default (url, prefix) => connect(`${url}`, prefix);
